import type User from "@/models/user";
import UserRepository from "@/repositories/userRepository";
import { defineStore } from "pinia";
import { ref } from "vue";
import { useAuthStore } from "./auth";

export const useUserStore = defineStore("user", () => {
  const user = ref<User | null>(null);

  async function getUser() {
    const auth = useAuthStore();
    if (!auth.isAuthenticated) return;
    user.value = await UserRepository.get();
  }

  return { user, getUser };
});
